import Box from '@mui/material/Box';
import * as Sentry from '@sentry/react';
import React, { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Router from './index';
import RenderFooter from './renderFooter';
import { LayoutMenu } from '../components/Layout/Menu/Layouts/LayoutMenu';
import { useMediaQuery, useTheme } from '@mui/material';

const tagManagerArgs = {
  gtmId: 'GTM-M4P54VX',
};

TagManager.initialize(tagManagerArgs);

const AppLayout = () => {
  const user = useSelector(state => state.auth.user);
  const location = useLocation();
  const [current, setCurrent] = React.useState('home');
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md'));
  const showFooter = Boolean(user);

  useEffect(() => {
    if (!user) Sentry.setUser(null);
    if (user) {
      Sentry.setUser({ email: user.email });
      Sentry.setExtra('securityId', user.sub);
    }
  }, [user]);

  TagManager.dataLayer({
    dataLayer: {
      userID: user ? user.sub : '',
      event: 'login',
      path: '/login',
    },
  });

  React.useEffect(() => {
    const pathname = location.pathname.replace('/', '');
    setCurrent(pathname ? pathname : 'home');
  }, [location.pathname]);

  return (
    <>
      <LayoutMenu>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
            paddingBottom: showFooter && isMobileOrTablet ? '81px' : '0px',
          }}>
          <Box sx={{ flex: 1 }}>
            <Router />
          </Box>
          <RenderFooter />
        </Box>
      </LayoutMenu>
    </>
  );
};

export default Sentry.withProfiler(AppLayout);
